import { render, staticRenderFns } from "./MedicalAppointmentFilter.vue?vue&type=template&id=2dd45914&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd45914",
  null
  
)

export default component.exports